import type { paths } from "@/api-schema";
import { useCompanyGroupByUuidQuery } from "@/common/api/company-group/use-company-group-by-uuid.query";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { FormCard } from "@/components/ui/form-card";
import { UuidExistenceWrapper } from "@/components/uuid-existence-wrapper/uuid-existence-wrapper";
import { useTranslation } from "react-i18next";
import { useParams } from "wouter";
import { CompanyGroupUpdateFormFields } from "./_components/update-form-fields";

interface UpdateViewParams {
  uuid: string;
}

export function UpdateView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const params = useParams<UpdateViewParams>();
  const uuid = params.uuid;

  return (
    <UuidExistenceWrapper<
      paths["/v1/company-group/{uuid}"]["get"]["parameters"]["query"],
      paths["/v1/company-group/{uuid}"]["get"]["responses"][200]["content"]["application/json"]
    >
      uuid={uuid}
      query={useCompanyGroupByUuidQuery}
      notFoundProps={{
        title: t("masterdata:CompanyGroupNotFound"),
        message: t("masterdata:CompanyGroupDoesNotExist"),
        description: t("masterdata:CheckCompanyGroupIdOrContactSupport"),
        backTo: "~/masterdata/company-group",
        backToLabel: t("masterdata:BackToCompanyGroupOverview"),
      }}
    >
      <UpdateViewContent uuid={uuid} />
    </UuidExistenceWrapper>
  );
}

function UpdateViewContent({ uuid }: { uuid: string }) {
  const { t } = useTranslation(["masterdata", "common"]);

  return (
    <CenteredLayout
      variant={CenteredLayoutVariant.Form}
      title={t("masterdata:EditCompanyGroup")}
      subTitle={t("common:ReviewAndSaveChangesDescription")}
    >
      <FormCard title={t("common:Details")} titleHidden>
        <CompanyGroupUpdateFormFields uuid={uuid} />
      </FormCard>
    </CenteredLayout>
  );
}
